(() => {
  (function (Drupal, once) {
    'use strict';
    const DEFAULT_FIELD_NAME = 'field_event_category_target_id';

    function normalize(text) {
      return (text || '').trim().toLowerCase();
    }

    function isAllLabel(labelNorm) {
      return (
        labelNorm === '__all__' ||
        labelNorm === 'all' ||
        labelNorm === 'alle' ||
        labelNorm === '- alle -'
      );
    }

    function getFieldSelect(form, fieldName) {
      if (!form) return null;
      return (
        form.querySelector(`select[name="${fieldName}"]`) ||
        form.querySelector(`select[name="${fieldName}[]"]`)
      );
    }

    function getFieldInputs(form, fieldName) {
      if (!form) return [];
      return Array.from(
        form.querySelectorAll(`input[name="${fieldName}"], input[name="${fieldName}[]"]`)
      );
    }

    function getInputLabel(input) {
      const id = input.getAttribute('id');
      if (id && input.form) {
        const label = input.form.querySelector(`label[for="${id}"]`);
        if (label) return label.textContent;
      }
      const parentLabel = input.closest('label');
      return parentLabel ? parentLabel.textContent : '';
    }

    function getCurrentLabel(form, fieldName) {
      const select = getFieldSelect(form, fieldName);
      if (select) {
        const opt = select.options[select.selectedIndex];
        return opt ? normalize(opt.textContent) : '';
      }
      const inputs = getFieldInputs(form, fieldName).filter((i) => i.checked);
      if (inputs.length) {
        return normalize(getInputLabel(inputs[0]));
      }
      return '';
    }

    function applyCategoryValue(form, fieldName, badgeLabel) {
      const labelNorm = normalize(badgeLabel);
      const select = getFieldSelect(form, fieldName);

      if (select) {
        if (isAllLabel(labelNorm)) {
          let matchedAll = false;
          Array.from(select.options).forEach((opt) => {
            if (matchedAll) return;
            const optLabel = normalize(opt.textContent);
            const optValue = normalize(opt.value);
            if (opt.value === '' || optValue === 'all' || isAllLabel(optLabel)) {
              select.value = opt.value;
              matchedAll = true;
            }
          });
          if (!matchedAll) select.value = '';
          return matchedAll;
        }
        let found = false;
        Array.from(select.options).forEach((opt) => {
          if (!found && normalize(opt.textContent) === labelNorm) {
            select.value = opt.value;
            found = true;
          }
        });
        if (!found) select.value = '';
        return found;
      }

      const inputs = getFieldInputs(form, fieldName);
      if (inputs.length) {
        if (isAllLabel(labelNorm)) {
          let matchedAll = false;
          inputs.forEach((input) => {
            const inputLabel = normalize(getInputLabel(input));
            const isAll = input.value === 'All' || isAllLabel(inputLabel);
            if (isAll) {
              input.checked = true;
              matchedAll = true;
            } else {
              input.checked = false;
            }
          });
          return matchedAll;
        }
        let matched = false;
        inputs.forEach((input) => {
          const inputLabel = normalize(getInputLabel(input));
          const isMatch = inputLabel === labelNorm;
          if (isMatch) matched = true;
          input.checked = isMatch;
        });
        if (!matched) inputs.forEach((i) => (i.checked = false));
        return matched;
      }

      return false;
    }

    Drupal.behaviors.eventsTopicFilter = {
      attach: function (context) {
        once('eventsTopicFilter', '[data-filter-events-category]', context).forEach(function (container) {
          let badges = container.querySelectorAll('.badge');
          const form = container.closest('form') || (container.closest('.events-view') || document).querySelector('form');
          const fieldName = container.getAttribute('data-category-field') || DEFAULT_FIELD_NAME;

          function sortBadges() {
            const allBadge = container.querySelector('[data-category-value="__all__"]');
            const others = Array.from(container.querySelectorAll('.badge'))
              .filter((b) => b !== allBadge)
              .sort((a, b) => a.textContent.localeCompare(b.textContent, undefined, { sensitivity: 'base' }));
            if (allBadge) container.appendChild(allBadge);
            others.forEach((b) => container.appendChild(b));
            badges = container.querySelectorAll('.badge');
          }

          sortBadges();

          function submitForm() {
            if (!form) return;
            const submitBtn = form.querySelector('.form-submit, input[type="submit"], button[type="submit"]');
            if (submitBtn) {
              submitBtn.click();
              return;
            }
            if (typeof form.requestSubmit === 'function') {
              form.requestSubmit();
            } else {
              form.submit();
            }
          }

          function setPressed(badge, isActive) {
            badge.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          }

          badges.forEach(function (badge) {
            badge.addEventListener('click', function () {
              if (badge.classList.contains('is-active')) return;
              badges.forEach(function (b) {
                b.classList.remove('is-active');
                setPressed(b, false);
              });
              badge.classList.add('is-active');
              setPressed(badge, true);
              applyCategoryValue(form, fieldName, badge.getAttribute('data-category-value'));
              submitForm();
            });
          });

          let initial = getCurrentLabel(form, fieldName) || '__all__';
          if (isAllLabel(initial)) {
            initial = '__all__';
          } else if (initial !== '__all__' && !container.querySelector('[data-category-value="' + initial + '"]')) {
            initial = '__all__';
          }
          badges.forEach((b) => b.classList.remove('is-active'));
          const initBadge = container.querySelector('[data-category-value="' + initial + '"]');
          if (initBadge) {
            initBadge.classList.add('is-active');
          }
          badges.forEach(function (b) {
            setPressed(b, b.classList.contains('is-active'));
          });
        });
      }
    };
  })(Drupal, once);
})();


